import { sanitizePasswordInput } from "@/helpers/sanitizePasswordInput";
import { Routes } from "@/router/routes";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function useSignUpForm() {
  const [formValues, setFormValues] = useState<{
    name: string;
    email: string;
    password: string;
    confirmPw: string;
    timezone: number;
  }>({
    email: "",
    name: "",
    password: "",
    confirmPw: "",
    timezone: 0,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (field: keyof typeof formValues, value: string) => {
    if (field === "password" || field === "confirmPw") {
      const sanitizedValue = sanitizePasswordInput(value, setErrorMessage);
      setFormValues((prev) => ({ ...prev, [field]: sanitizedValue }));
    } else {
      setFormValues((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    const { email, name, password, confirmPw, timezone } = formValues;

    if (!email || !name || !password || !confirmPw || !timezone) {
      setErrorMessage("すべての項目を入力してください。");
      return false;
    }

    if (password !== confirmPw) {
      setErrorMessage("パスワードが一致しません。");
      return false;
    }

    setErrorMessage("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const requestBody = {
      name: formValues.name,
      email: formValues.email,
      password: formValues.password,
      timezone: formValues.timezone,
    };

    try {
      setIsSubmitting(true);
      const response = await fetch("/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      
      const data = await response.json();
      if (response.ok) {
        console.log(data.message);
        navigate(Routes.LOGIN);
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || "登録に失敗しました。");
      }
    } catch (error) {
      setErrorMessage("サーバーとの通信に失敗しました。");
      console.error("エラー:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formValues,
    errorMessage,
    showPassword,
    showConfirmPassword,
    setShowPassword,
    setShowConfirmPassword,
    handleChange,
    handleSubmit,
    isSubmitting,
  };
}
